import React from 'react'
import tw from 'twin.macro'
import { Outlet } from 'react-router-dom'
import { SecureWrapper } from 'src/components/layout/SecureWrapper'

export const DashboardPage = () => {
  return (
    <SecureWrapper>
      {/* `h-full` so pages that lay themselves out as a full-height flex column (Priority queue)
          have a definite height to divide; pages with auto-height content are unaffected. */}
      <div data-testid="dashboard-layout-page" css={tw`h-full`}>
        <Outlet />
      </div>
    </SecureWrapper>
  )
}
